

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import MainSphere from '../components/main-sphere'

import {
    startSpeech
} from "../actions/microphone";

import {
    setWorldState
} from "../actions"


const mapStateToProps = (state) => {
    return {
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setWorldState: setWorldState,
        startSpeech: startSpeech,
    }, dispatch);
}

export default connect(
    mapStateToProps,
    matchDispatchToProps
)(MainSphere);



// WEBPACK FOOTER //
// ./src/containers/main-sphere.js